<template>
  <div>
    <b-card body-class="p-1">
      <b-row class="pb-1"
      >
        <b-col cols="8">
          <h4>Danh sách</h4>
        </b-col>
        <b-col class="text-right" cols="4">
          <b-button class="btn-sm" variant="primary" @click="New()">
            <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
            Thêm Campaign
          </b-button>
          <b-button
              class="btn-sm ml-1"
              variant="primary"
              @click="importDialog()"
          >
            <feather-icon
                class="align-text-top"
                icon="FilePlusIcon"
                size="16"
            />
            Import
          </b-button>
          <b-button
              class="btn-sm ml-1"
              variant="primary"
              @click="$bvModal.show('modal-export-excel')"
          >
            <feather-icon
                class="align-text-top"
                icon="FileMinusIcon"
                size="16"
            />
            Export
          </b-button>
        </b-col>
        <b-col class="mt-1" cols="12">
          <b-row>
            <b-col cols="2">
              <flatPickr
                  v-model="dateCampaignFrom"
                  class="form-control"
                  @on-change="onDateCampaignFromChange"
              />
            </b-col>
            <b-col cols="2">
              <flatPickr
                  v-model="dateCampaignTo"
                  class="form-control"
                  @on-change="onDateCampaignToChange"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col class="pt-1" cols="12">
          <vue-good-table
              :columns="campaign_fields"
              :isLoading.sync="isLoading"
              :line-numbers="true"
              :pagination-options="{
              perPage: serverParams.pageSize,
              enabled: true,
            }"
              :rows="campaign_items"
              :totalRows="totalRecords"
              mode="remote"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'short_url'"
              ><a :href="getUrl(props.row)" target="_blank">{{
                  getUrl(props.row)
                }}</a></span
              >
              <span v-if="props.column.field === 'action'">
                <b-button
                    class="btn-icon"
                    size="sm"
                    variant="primary"
                    @click="Edit(props.row, props.row.id)"
                >
                  <feather-icon icon="Edit2Icon"/>
                </b-button>
                <b-button
                    class="btn-icon"
                    size="sm"
                    style="margin-left: 6px"
                    variant="danger"
                    @click="Delete(props.row, props.row.id)"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
                <b-button
                    class="btn-icon"
                    size="sm"
                    style="margin-left: 6px"
                    variant="primary"
                    @click="clone(props.row, props.row.id)"
                >
                  <feather-icon icon="PlusIcon"/>
                </b-button>
              </span>
              <span v-else-if="props.column.field === 'Status'">
                <b-badge v-if="props.row.Status == 1" variant="primary"
                >Active</b-badge
                >
                <b-badge v-else variant="secondary">Inactive</b-badge>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
        id="modal-campaign-edit"
        :title="getTitle()"
        ok-title="Lưu"
        size="lg"
        @ok="handleOk"
    >
      <validation-observer ref="modalCampaignEdit">
        <b-row>
          <b-col cols="12">
            <validation-provider rules="required">
              <b-form-group label="Campaign Name *">
                <Select2
                    v-model="currentItem.utm_campaign"
                    :options="campaigns"
                    :settings="{}"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col v-if="links.length > 1" cols="12">
            <b-form-group label="Links">
              <Select2
                  v-model="currentItemSelectedLink"
                  :options="links"
                  :settings="{}"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="required">
              <b-form-group label="Source *">
                <Select2
                    v-model="currentItem.utm_source"
                    :options="channels"
                    :settings="{}"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="required">
              <b-form-group label="Medium *">
                <Select2
                    v-if="currentItem && getMedium()"
                    v-model="currentItem.utm_medium"
                    :options="getMedium()"
                    :settings="{}"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="required">
              <b-form-group label="Content *">
                <b-form-input
                    v-model="currentItem.utm_content"
                    placeholder="utm content"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="required">
              <b-form-group label="Agency *">
                <b-form-input v-model="currentItem.user" disabled/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="">
              <b-form-group label="Content URL / Keyword">
                <b-form-input
                    v-model="currentItem.keyword"
                    placeholder="Content URL/Keyword"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="">
              <b-form-group label="Target audience">
                <b-form-input
                    v-model="currentItem.target_audience"
                    placeholder="Target audience"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider rules="">
              <b-form-group label="Danh mục số">
                <Select2
                    v-if="currentItem && getMedium()"
                    v-model="currentItem.sim_category_id"
                    :options="SimCategorys"
                    :settings="{}"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col class="text-primary mb-1" cols="12">
            <div
                v-if="!currentItem.sim_category_id && currentItemSelectedLink"
                class="border rounded bg-light font-weight-bold"
                style="padding: 3px 6px"
            >
              {{ currentItemSelectedLink }}?utm_source={{
                currentItem.utm_source
              }}&utm_medium={{ currentItem.utm_medium }}&utm_content={{
                currentItem.utm_content
              }}&utm_campaign={{ currentItem.utm_campaign }}
            </div>
            <div
                v-if="currentItem.sim_category_id && currentItemSelectedLink"
                class="border rounded bg-light font-weight-bold"
                style="padding: 3px 6px"
            >
              {{ currentItemSelectedLink }}?utm_source={{
                currentItem.utm_source
              }}&utm_medium={{ currentItem.utm_medium }}&utm_content={{
                currentItem.utm_content
              }}&utm_campaign={{
                currentItem.utm_campaign
              }}&sim_category_id_sort={{ currentItem.sim_category_id }}
            </div>
          </b-col>
          <b-col
              v-if="getUrl()"
              align-self="center"
              class="text-success"
              cols="8"
          >
            <div
                class="border rounded bg-light font-weight-bold"
                style="padding: 3px 6px"
            >
              <a :href="getUrl()" target="_blank">{{ getUrl() }}</a>
            </div>
          </b-col>
          <b-col v-if="getUrl()" cols="4">
            <b-button
                id="btn-copy-link"
                class="float-right mt-1 mb-1 text-left"
                size="sm"
                style="width: 100%"
                variant="primary"
                @click="copyUrl"
                @mouseout="outFunc"
            >
              <span id="tooltiptext-copy" class="tooltiptext"
              >Copy to clipboard</span
              >
              Copy link
            </b-button>
          </b-col>
          <b-col v-if="editMode" cols="12">
            <b-button
                class="float-right mt-1 mb-1"
                size="sm"
                variant="primary"
                @click="NewCost()"
            >Thêm mới chi phí tuần
            </b-button
            >
          </b-col>
          <b-col v-if="editMode" cols="12">
            <vue-good-table
                :columns="cost_fields"
                :line-numbers="true"
                :pagination-options="{ enabled: false }"
                :rows="cost_items"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'action'">
                  <b-button
                      class="btn-icon"
                      size="sm"
                      variant="primary"
                      @click="EditCost(props.row, props.row.id)"
                  >
                    <feather-icon icon="Edit2Icon"/>
                  </b-button>
                  <b-button
                      class="btn-icon"
                      size="sm"
                      style="margin-left: 6px"
                      variant="danger"
                      @click="DeleteCost(props.row, props.row.id)"
                  >
                    <feather-icon icon="TrashIcon"/>
                  </b-button>
                </span>
                <span v-else-if="props.column.field === 'Status'">
                  <b-badge v-if="props.row.Status == 1" variant="primary"
                  >Active</b-badge
                  >
                  <b-badge v-else variant="secondary">Inactive</b-badge>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-cost-edit"
        :title="getTitle()"
        ok-title="Lưu"
        @ok="handleCostOk"
    >
      <validation-observer ref="modalCostEdit">
        <b-row>
          <b-col cols="12">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Cost (VNĐ) *">
                <b-form-input
                    v-model="currentCost.Cost"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Cost (VNĐ)"
                    type="number"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Từ ngày *">
                <b-form-datepicker
                    v-model="currentCost.StartDate"
                    :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                    :state="errors.length > 0 ? false : null"
                    locale="vi-VN"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group label="Đến ngày *">
                <b-form-datepicker
                    v-model="currentCost.EndDate"
                    :date-format-options="{
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  }"
                    :state="errors.length > 0 ? false : null"
                    locale="vi-VN"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12"><small>Nhập từ thứ 2 đến chủ nhật</small></b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-import-excel"
        :title="'Import excel file'"
        ok-title="Lưu"
        size="lg"
        @ok="importExcelOk"
    >
      <b-row align-v="center" class="ml-0 mr-0">
        <b-button
            class="btn-sm mr-50"
            style="color: black"
            variant="outline-primary"
            @click="$refs.inputImportExcelFile.click()"
        >
          <feather-icon class="align-text-top" icon="UploadIcon" size="16"/>
          Upload file
        </b-button>
        <span v-if="file && file.name">{{ file.name }}</span>
        <span v-else style="color: #ed1f24">Vui lòng chọn file!</span>
        <template
            v-if="
            sampleImportExcelErrorConfig.data &&
            sampleImportExcelErrorConfig.data.length > 0
          "
        >
          <vue-excel-xlsx
              :columns="sampleImportExcelErrorConfig.columns"
              :data="sampleImportExcelErrorConfig.data"
              :file-name="'ErrorTemplate'"
              :file-type="'xlsx'"
              :sheet-name="'error'"
              class="btn btn-sm btn-outline-primary ml-auto"
              style="color: black; margin-right: 4px"
          >
            <feather-icon
                class="align-text-top"
                icon="DownloadIcon"
                size="16"
            />
            Tải file thông báo lỗi
          </vue-excel-xlsx>
        </template>
        <input
            ref="inputImportExcelFile"
            accept=".xls*"
            class="fileSelect"
            style="display: none"
            type="file"
            @change="fileChange($event)"
        />
      </b-row>
      <template #modal-footer>
        <vue-excel-xlsx
            :columns="sampleImportExcelConfig.columns"
            :data="sampleImportExcelConfig.data"
            :file-name="'campaignTemplate'"
            :file-type="'xlsx'"
            :sheet-name="'sheet1'"
            class="btn btn-sm mr-50 btn-outline-primary m-0"
            style="color: black"
        >
          <feather-icon class="align-text-top" icon="DownloadIcon" size="16"/>
          Tải file mẫu
        </vue-excel-xlsx>
        <b-button
            class="ml-auto"
            variant=""
            @click="$bvModal.hide('modal-import-excel')"
        >Cancel
        </b-button
        >
        <b-button class="ml-1" variant="primary" @click="importExcelOk"
        >Ok
        </b-button
        >
      </template>
    </b-modal>
    <b-modal
        id="modal-export-excel"
        :title="'Chọn cột để xuất excel file'"
        ok-title="Ok"
        size="lg"
    >
      <b-row>
        <b-col
            v-for="(item, index) in campaign_fields"
            v-bind:key="index"
            cols="3"
        >
          <b-form-checkbox
              v-model="item.isExported"
              @change="onColumnCheckChange(item)"
          >
            {{ item.label }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <template #modal-footer>
        <span v-if="showNoDataWarning" style="color: red"
        >Không có dữ liệu!</span
        >
        <b-button
            class="ml-auto"
            variant=""
            @click="$bvModal.hide('modal-export-excel')"
        >Cancel
        </b-button
        >
        <vue-excel-xlsx
            :columns="campaign_fieldsExport"
            :data="campaign_itemsExport"
            :file-name="'subCampaigns'"
            :file-type="'xlsx'"
            :sheet-name="'sheet1'"
            class="border-0 bg-transparent ml-1 p-0"
        >
          <b-button class="ml-1" variant="primary">Ok</b-button>
        </vue-excel-xlsx>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import Moment from "moment";
import VueTagsInput from "@johmun/vue-tags-input";
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import {extendMoment} from "moment-range";
import {$ctx} from "@themeConfig";
import mixinCampaign from "./mixin/index";

const TinyURL = require("tinyurl");
Vue.use(VueExcelXlsx);

const moment = extendMoment(Moment);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCardText,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BTab,
    BTabs,
    VueTagsInput,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    flatPickr,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadItems();
    this.onColumnCheckChange();
  },
  watch: {
    campaign_items: function (newValue, oldValue) {
      this.getSimConfigGroup();
      this.campaign_itemsExport = [];
      const startDate = moment(this.dateCampaignFrom);
      const endDate = moment(this.dateCampaignTo);

      const weeks = this.splitWeeks(this.dateCampaignFrom, this.dateCampaignTo);

      newValue.forEach((i) => {
        weeks.forEach((w) => {
          const tempItem = JSON.parse(JSON.stringify(i));
          tempItem.startDate = w.start.format("yyyy-MM-DD");
          tempItem.endDate = w.end.format("yyyy-MM-DD");

          if (
              this.campaign_itemsExport.find((c) => c.utm_id === tempItem.utm_id)
          )
            tempItem.TotalCost = null;

          this.campaign_itemsExport.push(tempItem);
        });

        i.accumm = 0;
        useJwt
            .post("getMasterData/B2C_Campaign_Cost", {
              columnFilters: {campaign_id: i.utm_id},
              sort: [],
              page: 1,
              pageSize: 50,
            })
            .then((response) => {
              const cost_weeks = response.data.result;
              let accumm = 0;

              if (cost_weeks.length > 0) {
                cost_weeks.forEach((c) => {
                  const startWeekDate = moment(c.StartDate);
                  const endWeekDate = moment(c.EndDate);
                  let startDateValue = c.StartDate;
                  let endDateValue = c.EndDate;

                  if (startDate < endWeekDate && startWeekDate < endDate) {
                    if (startWeekDate < startDate)
                      startDateValue = startDate.format("yyyy-MM-DD");
                    if (endWeekDate > endDate)
                      endDateValue = endDate.format("yyyy-MM-DD");
                  }

                  const crc = this.campaign_itemsExport.find(
                      (c) => c.utm_id === i.utm_id && c.startDate === startDateValue
                  );
                  if (crc) {
                    crc.weekCost = c.Cost;
                    accumm += c.Cost;
                    crc.accumm = accumm;
                  }
                });
              } else {
              }
            });
      });
    },
    "currentItem.utm_campaign": function (newValue, oldValue) {
      this.loadLinks();
    },
  },
  mixins: [mixinCampaign],
  methods: {
    getUrl(item) {
      if (item && item.utm_campaign) {
        return `${$ctx.URL_FRONTEND}/-/${
            item.utm_id
        }/${item.utm_campaign.replace(/\//, "-")}`;
      } else if (this.currentItem && this.currentItem.utm_campaign) {
        return `${$ctx.URL_FRONTEND}/-/${
            this.currentItem.utm_id
        }/${this.currentItem.utm_campaign.replace(/\//, "-")}`;
      } else {
        return "";
      }
    },
    getMedium() {
      var m = [];
      if (this.currentItem.utm_source) {
        this.channels
            .find((i) => i.id == this.currentItem.utm_source)
            .utm_medium.split(",")
            .forEach((i) => {
              m.push({id: i, text: i});
            });
      }
      return m;
    },
    loadLinks() {
      const campaign = this.campaigns.find(
          (i) => i.id === this.currentItem.utm_campaign
      );

      this.links = campaign !== undefined ? campaign.url.split(",") : [];

      this.currentItemSelectedLink = this.links.length > 0 ? this.links[0] : "";
    },
    getSimConfigGroup() {
      useJwt
          .post("getMasterData/SimCategory", {
            columnFilters: {},
            sort: [],
            page: 1,
            pageSize: 200,
            lang: 1,
          })
          .then((response) => {
            this.SimCategorys = response.data.result.map((item) => {
              return {
                ...item,
                text: item.Name,
                id: item.Id,
              };
            });
          });
    },
    loadItems() {
      this.loading(true);

      // this.serverParams.columnFilters.StartTime = moment(
      //   this.dateCampaignFrom
      // ).format("yyyy-MM-DDTHH:mm:ss");
      // this.serverParams.columnFilters.EndTime = moment(
      //   this.dateCampaignTo
      // ).format("yyyy-MM-DDTHH:mm:ss");
      useJwt
          .post("getMasterData/B2C_Campaign", this.serverParams)
          .then((response) => {
            this.campaign_items = response.data.result;
            this.channels = response.data.extra.channel;
            this.users = response.data.extra.user;
            this.campaigns = response.data.extra.utm_campaign;
            this.totalRecords = response.data.totalRecords;
            this.isLoading = false;
            this.loading(false);
          });
    },
    Edit(item, index, button) {
      this.currentItem = JSON.parse(JSON.stringify(item));
      this.currentItem.user = this.getUser();

      this.loadLinks();
      if (this.currentItem.url)
        this.currentItemSelectedLink = this.currentItem.url;

      this.mediums = [];
      this.editMode = true;
      useJwt
          .post("getMasterData/B2C_Campaign_Cost", {
            columnFilters: {campaign_id: this.currentItem.utm_id},
            sort: [],
            page: 1,
            pageSize: 50,
          })
          .then((response) => {
            this.cost_items = response.data.result;
            this.$bvModal.show("modal-campaign-edit");
          });
    },
    NewCost() {
      this.currentCost = {};
      this.editCostMode = false;
      this.$bvModal.show("modal-cost-edit");
    },
    EditCost(item) {
      this.currentCost = item;
      this.editCostMode = true;
      this.$bvModal.show("modal-cost-edit");
    },
    New() {
      this.currentItem = {user: this.getUser()};
      this.editMode = false;
      if (this.tabIndex == 0) {
        this.$bvModal.show("modal-channel-edit");
      } else if (this.tabIndex == 1) {
        this.$bvModal.show("modal-config-edit");
      } else {
        this.isLoading = true;
        useJwt.get("getCampaignId").then((response) => {
          this.currentItem.utm_id = response.data.result;
          this.isLoading = false;
        });
        this.$bvModal.show("modal-campaign-edit");
      }
    },
    importDialog() {
      this.$bvModal.show("modal-import-excel");
    },
    importExcelOk() {
      if (
          this.currentDataImportExcelFile &&
          this.currentDataImportExcelFile.length > 0
      ) {
        const resultValidation = this.validateImportCampaigns(
            this.currentDataImportExcelFile
        );
        if (!resultValidation.isSuccess) {
          this.sampleImportExcelErrorConfig.data = resultValidation.errorRows;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Nhập file thất bại!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        this.isLoading = true;
        this.sampleImportExcelErrorConfig.data = [];

        useJwt
            .post("B2C_Campaign_Cost/import", {
              rows: this.currentDataImportExcelFile,
            })
            .then((res) => {
              this.isLoading = false;

              if (
                  res.data.result &&
                  res.data.result.length &&
                  res.data.result.length > 0
              ) {
                let errorText = "";
                res.data.result.forEach((i) => {
                  this.sampleImportExcelErrorConfig.data.push(i);
                });

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Nhập file thất bại!",
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                });
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: res.data.message,
                    icon: "CheckSquareIcon",
                    variant: "success",
                  },
                });
                this.loadItems();
              }
            });
      }
    },
    fileChange(event) {
      this.currentDataImportExcelFile = [];
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: "binary"});
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws, {header: 1});

          const fields = [];
          for (let i = 0; i < data.length; i++) {
            if (i === 0) {
              data[i].forEach((f) => {
                switch (f) {
                  case "weekCost":
                    f = "cost";
                    break;
                  case "ID":
                    f = "campaign_id";
                    break;

                  default:
                    break;
                }

                fields.push(f);
              });
            } else {
              const row = {};
              for (let j = 0; j < fields.length; j++) {
                row[`${fields[j]}`] = data[i][j];
              }

              this.currentDataImportExcelFile.push(row);
            }
          }
        };

        reader.readAsBinaryString(this.file);
      }
    },
    async handleCostOk(bvModalEvt) {
      this.currentCost.campaign_id = this.currentItem.utm_id;
      bvModalEvt.preventDefault();
      var validate = await this.$refs.modalCostEdit
          .validate()
          .then((success) => {
            return success;
          });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (!this.editCostMode) {
        useJwt
            .post("masterData/B2C_Campaign_Cost", this.currentCost)
            .then((response) => {
              useJwt
                  .post("getMasterData/B2C_Campaign_Cost", {
                    columnFilters: {campaign_id: this.currentItem.utm_id},
                    sort: [],
                    page: 1,
                    pageSize: 50,
                  })
                  .then((response) => {
                    this.cost_items = response.data.result;
                  });
              this.$bvModal.hide("modal-cost-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Thêm mới thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi thêm mới [" + error.response.data.result + "]!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      } else {
        useJwt
            .put("B2C_Campaign_Cost", this.currentCost)
            .then((response) => {
              useJwt
                  .post("getMasterData/B2C_Campaign_Cost", {
                    columnFilters: {campaign_id: this.currentItem.utm_id},
                    sort: [],
                    page: 1,
                    pageSize: 50,
                  })
                  .then((response) => {
                    this.cost_items = response.data.result;
                  });
              this.$bvModal.hide("modal-cost-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cập nhật thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi cập nhật [" + error.response.data.result + "]!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      }
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.currentItem.url = this.currentItemSelectedLink;
      var validate = await this.$refs.modalCampaignEdit
          .validate()
          .then((success) => {
            return success;
          });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (!this.editMode) {
        useJwt
            .post("masterData/B2C_Campaign", this.currentItem)
            .then((response) => {
              this.loadItems();
              this.$bvModal.hide("modal-campaign-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Thêm mới thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi thêm mới!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      } else {
        useJwt
            .put("B2C_Campaign", this.currentItem)
            .then((response) => {
              this.loadItems();
              this.$bvModal.hide("modal-campaign-edit");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cập nhật thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi cập nhật!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      }
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu ",
          {title: "Please Confirm", size: "sm"}
      );
      if (res) {
        useJwt
            .delete(`masterData/B2C_Campaign/${item.utm_id}`, {})
            .then((response) => {
              this.loadItems();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Xoá thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi xoá dữ liệu!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      }
    },
    async clone(item, index, button) {
      this.editMode = false;
      this.currentItem = item;
      this.currentItem.user = this.getUser();

      if (this.tabIndex == 0) {
      } else if (this.tabIndex == 1) {
      } else {
        this.$bvModal.show("modal-campaign-edit");
      }
    },
    async DeleteCost(item, index, button) {
      this.currentCost = item;
      var res = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu ",
          {title: "Please Confirm", size: "sm"}
      );
      if (res) {
        useJwt
            .delete("masterData/B2C_Campaign_Cost/" + item.id, {})
            .then((response) => {
              useJwt
                  .post("getMasterData/B2C_Campaign_Cost", {
                    columnFilters: {campaign_id: this.currentItem.utm_id},
                    sort: [],
                    page: 1,
                    pageSize: 50,
                  })
                  .then((response) => {
                    this.cost_items = response.data.result;
                  });
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Xoá thành công!",
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            })
            .catch((error) => {
              console.log(error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi xoá dữ liệu!",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
      }
    },
    //default function
    getTitle() {
      if (this.editMode) {
        return "Cập nhật";
      } else {
        return "Thêm mới";
      }
    },
    getUser() {
      return JSON.parse(localStorage.userData).username;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },
    copyUrl() {
      const url = this.getUrl();
      navigator.clipboard.writeText(url);

      var tooltip = document.getElementById("tooltiptext-copy");
      tooltip.innerHTML = "Copied: " + url;
    },
    outFunc() {
      var tooltip = document.getElementById("tooltiptext-copy");
      tooltip.innerHTML = "Copy to clipboard";
    },
    onDateCampaignFromChange(e) {
      this.loadItems();
    },
    onDateCampaignToChange(e) {
      this.loadItems();
    },
    onColumnCheckChange(e) {
      this.campaign_fieldsExport = [];
      const temData = JSON.parse(JSON.stringify(this.campaign_fields));
      temData.forEach((f) => {
        if (f.isExported) this.campaign_fieldsExport.push(f);
      });
      this.campaign_fieldsExport.push(...this.tempCampaign_fieldsExport);
    },
    getMinDate(days) {
      let min = moment("9999-12-30");
      days.forEach((i) => {
        if (i < min) {
          min = i;
        }
      });
      return min;
    },
    getMaxDate(days) {
      let max = moment("0001-01-01");
      days.forEach((i) => {
        if (i > max) {
          max = i;
        }
      });
      return max;
    },
  },
  data() {
    return {
      SimCategorys: [],
      short_url: "",
      isLoading: false,
      totalRecords: 0,
      editCostMode: false,
      campaign_items: [],
      campaign_itemsExport: [],
      cost_items: [],
      editMode: false,
      currentItem: {},
      currentItemSelectedLink: "",
      currentCost: {},
      campaign_fields: [
        {
          field: "utm_id",
          filterOptions: {enabled: true, placeholder: ""},
          label: "ID",
          width: "120px",
          isExported: true,
        },
        {
          field: "utm_campaign",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Campaign Name",
          isExported: true,
        },
        {
          field: "utm_content",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Content",
          isExported: true,
        },
        {
          field: "utm_source",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Source",
          isExported: true,
        },
        {
          field: "utm_medium",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Medium",
          isExported: true,
        },
        {
          field: "user",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Agency",
          isExported: true,
        },
        {
          field: "Cost",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Cost",
          isExported: true,
        },
        {
          field: "TotalCost",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Tổng chi phí",
          tdClass: "text-right",
          isExported: true,
        },
        {
          field: "short_url",
          label: "Short link",
          tdClass: "text-left",
          isExported: true,
        },
        {
          field: "action",
          label: "Actions",
          width: "120px",
          tdClass: "text-center",
          isExported: true,
        },
      ],
      campaign_fieldsExport: [],
      tempCampaign_fieldsExport: [
        {
          field: "startDate",
          label: "startDate",
          isExported: true,
        },
        {
          field: "endDate",
          label: "endDate",
          isExported: true,
        },
        {
          field: "weekCost",
          label: "weekCost",
          isExported: true,
        },
        {
          field: "accumm",
          label: "Lũy kế",
          isExported: true,
        },
      ],
      cost_fields: [
        {
          field: "id",
          filterOptions: {enabled: true, placeholder: ""},
          label: "ID",
          width: "120px",
          hidden: true,
        },
        {
          field: "Cost",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Chi phí",
        },
        {
          field: "StartDate",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Từ ngày",
        },
        {
          field: "EndDate",
          filterOptions: {enabled: true, placeholder: ""},
          label: "Đến ngày",
        },
        {
          field: "action",
          label: "Actions",
          width: "90px",
          tdClass: "text-center",
        },
      ],
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
      },
      required,
      campaigns: [],
      links: [],
      channels: [],
      sampleImportExcelConfig: {
        columns: [
          {
            field: "campaign_id",
            label: "ID",
          },
          {
            field: "startDate",
            label: "startDate",
          },
          {
            field: "endDate",
            label: "endDate",
          },
          {
            field: "cost",
            label: "weekCost",
          },
        ],
        data: [
          {
            campaign_id: 1,
            startDate: "2022-09-01",
            endDate: "2022-09-13",
            cost: "20000",
          },
          {
            campaign_id: 2,
            startDate: "2022-09-14",
            endDate: "2022-09-25",
            cost: "50000",
          },
        ],
      },
      file: {},
      sampleImportExcelErrorConfig: {
        columns: [
          {
            field: "rowIndex",
            label: "Dòng",
          },
          {
            field: "note",
            label: "Thông báo lỗi",
          },
        ],
        data: [],
      },
      dateCampaignFrom: new Date().setDate(new Date().getDate() - 30),
      dateCampaignTo: new Date(),
    };
  },
  computed: {
    showNoDataWarning() {
      return this.campaign_items.length === 0;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style>
.ti-input {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.vue-tags-input {
  max-width: auto;
}
</style>

<style scoped>
.tooltiptext {
  visibility: hidden;
  position: absolute;
  background-color: #ed1f24;
  color: white;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  bottom: 100%;
}

#btn-copy-link:hover .tooltiptext {
  visibility: visible;
}

.tooltiptext::after {
  content: "";
  position: absolute;
  left: 25% !important;
  margin-left: -5px !important;
  top: 100% !important;
  border-width: 5px;
  border-style: solid;
  border-color: #ed1f24 transparent transparent transparent;
}
</style>
